import React, { Component } from 'react';

export default class Chapter1 extends Component {
  render() {
    return (
      <div>
        <div className="medium-padding joysetter-header">
          <h6 className="white">Jet Lag Tool Kit</h6>
          <h1 className="white">Chapter 1: Openhearted</h1>
          <p className="white"><b>How to open your heart so you can open your eyes</b></p>
        </div>
        <div className="toolkit-content">
          <ol >
            <li>Adopt a “Be first” mindset: be the first to smile, to say hello, to do a kind simple act of connection. Try this out with random strangers. Smile at someone as you are passing by on the sidewalk. It is truly contagious. Even if they don’t smile back, I guarantee they will feel the effects of your simple kindness and it will create a ripple effect.
            </li>
            <li>Use discomfort as a compass for openhearted action. Lean into the fear to take away its power and be kind to yourself if things don’t go as planned. Celebrate the fact that you tried and that you chose love over fear. It will get easier.
            </li>
            <li>Put your hands on your heart and breathe deeply. This action allows you to anchor to the heart and subconsciously helps you to get out of your mind and into your heart.
            </li>
            <li>Cultivating gratitude is a great way to get into your heart and assist in openhearted decision making. Make a list of things that you are grateful for and truly feel the joy and appreciation for each of those things.
            </li>
          </ol>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/toolkits/chapter1.js